import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { personalizeAction } from '../../../store/pesonalize-store';
import validateInfo from "../validateInfo";
import useHttp from '../../../hooks/use-http';
import { endPoints } from "../../../config/end-points";
import { cuteToast } from '../../UI/cute';
import { useEffect } from 'react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ImageUploadModal from '../../shared/modals/ImageUploadModal'
import ReactTooltip from 'react-tooltip';

const VideoSettings = () => {

    const dispatch = useDispatch();

    const [errors, setErrors] = useState({});
    const { sendRequest: updatePersonalizeData } = useHttp();

    const personalize_brandingData = useSelector(
        (state) => state.personalize.personalize_brandingData
    );

    // console.log(personalize_brandingData)
    const personalize_privacyData = useSelector(
        (state) => state.personalize.personalize_privacyData
    );

    const camp_id = useSelector((state) => state.campaign.camp_id);
    const thumbnailModal = useSelector((state) => state.personalize.personalize_thumbnailmodal);

    // console.log(thumbnailModal)
    const [brandingData,setBrandingData] = useState({
        player_logo:'',
        player_theme:'#ff3987',
        player_addlink_chk:false,
        player_link:'',
    })

    const [privacyData,setPrivacyData] = useState({
        visibility:'anyone',
        passwordchk:false,
        passwordText:"",
        expirarychk:false,
        expiraryTextTimeStamp:"",
    })

    const [expiraryText,setExpiraryText] = useState(new Date());

    useEffect(()=>{
        (personalize_brandingData && Object.keys(personalize_brandingData).length > 0) && setBrandingData(personalize_brandingData);
        if(personalize_privacyData && Object.keys(personalize_privacyData).length > 0){
            setPrivacyData(personalize_privacyData);
            setExpiraryText(new Date(personalize_privacyData.expiraryTextTimeStamp))
        } 
    },[personalize_brandingData,personalize_privacyData])
    
    const handleBrandingData = (event) =>{
        event.preventDefault();
        const validateData = validateInfo(brandingData,'branding');

        if (Object.keys(validateData).length > 0) {
            setErrors(validateData);
            return false;
        } else if (Object.keys(validateData).length === 0) {
            updatePersonalizeData({
                url: endPoints.addPersonalize,
                method: "POST",
                body: {
                    ...brandingData,
                    camp_id,
                    type: "video_branding"
                },
            }, (response) => {
                if (response.status === 200) {
                    dispatch(personalizeAction.setBrandingData({ personalize_brandingData: brandingData }))
                    cuteToast({
                        type: "success",
                        message: "Setting Saved Successfully.",
                        timer: 5000,
                        title: "Branding Setting",
                    });
                }
            });
        }
    }

    const handlePrivacyData = (event) =>{
        event.preventDefault();
        const validateData = validateInfo(privacyData,'privacy');

        if (Object.keys(validateData).length > 0) {
            setErrors(validateData);
            return false;
        } else if (Object.keys(validateData).length === 0) {
            updatePersonalizeData({
                url: endPoints.addPersonalize,
                method: "POST",
                body: {
                    ...privacyData,
                    camp_id,
                    type: "video_privacy"
                },
            }, (response) => {
                if (response.status === 200) {
                    // dispatch(personalizeAction.setPrivacyData({ personalize_privacyData: JSON.stringify(privacyData) }))
                    dispatch(personalizeAction.setPrivacyData({ personalize_privacyData: privacyData }))
                    cuteToast({
                        type: "success",
                        message: "Setting Saved Successfully.",
                        timer: 5000,
                        title: "privacy Setting",
                    });
                }
            });
        }
    }

    const handleDateChange = (date) =>{
        setPrivacyData({
            ...privacyData,
            expiraryTextTimeStamp:Date.parse(date)
        })
        setExpiraryText(date)
    }

    /*
    *   Rebuild or re-init React-tooltip 
    */
    useEffect(() => {
        ReactTooltip.rebuild();
    });

    return (
    <>
        <div className="row">
            <div className="col-md-3">
                <div className="video_setting_left shadow2 bg-white p-3 h-100">
                    <h6 className="mb-3">Video Settings</h6>

                    <ul className="nav nav-tabs" id="myTab" role="tablist">
                        
                        <li className="nav-item" role="presentation">
                            <button className="nav-link active" id="branding-tab" data-bs-toggle="tab" data-bs-target="#branding" type="button" role="tab" aria-controls="branding" aria-selected="false">Branding</button>
                        </li>
                        <li className="nav-item" role="presentation">
                            <button className="nav-link" id="privacy-tab" data-bs-toggle="tab" data-bs-target="#privacy" type="button" role="tab" aria-controls="privacy" aria-selected="false">Privacy</button>
                        </li>
                    </ul>

                </div>

            </div>


            <div className="col-md-9">
                <div className="tab-content p-5" id="myTabContent">
                   
                    <div className="tab-pane fade show active" id="branding" role="tabpanel" aria-labelledby="branding-tab">
                        <div className="branding_sec rounded bg_gry2 ">
                            <div className="brand_rw1 p-4 border-bottom">
                                <div className="row">
                                    <div className="col-md-3"><h6 className="m-0">Player Theme</h6></div>

                                    <div className="col-md-9">
                                        <div className="link_gry me-5" style={{verticalAlign:"top"}}>
                                            <i className="fa fa-circle" style={{color:"#ff3987"}}></i> 
                                            <label className='ms-2'>Default</label>
                                        </div> 
                                        {/* <button className="link_blue" onClick={handleColorPicker}>
                                            <i className="fa fa-pencil"></i> Change
                                        </button> */}
                                        
                                        <input 
                                            type="color" 
                                            id="color-picker" 
                                            value={brandingData.player_theme}
                                            onChange={(e)=>setBrandingData({...brandingData,player_theme:e.target.value})} 
                                            data-tip={"Change player theme"}
                                            data-effect="solid"
                                        />  
                                       
                                        {!thumbnailModal && <ImageUploadModal setBrandingData={setBrandingData} brandingData={brandingData} />}
                                        
                                    </div>
                                </div>

                            </div>


                            <div className="brand_rw2 p-4">
                                <div className="row align-items-center mb-4">
                                    <div className="col-md-3"><h6 className="m-0">Player Logo</h6></div>

                                    <div className="col-md-9 align-items-center">
                                        {(brandingData.player_logo && brandingData.player_logo.length > 0) && (
                                            <div className="player_logo d-inline-block me-5">
                                                <img 
                                                    src={brandingData.player_logo} 
                                                    alt="img" 
                                                    className='img-fluid'
                                                    style={{width:"60px"}}
                                                />
                                            </div>
                                        )}
                                        
                                        <a href="#importimageBranding" data-bs-toggle="modal" className="link_blue me-5">
                                            {(brandingData.player_logo && brandingData.player_logo.length > 0) ? (<><i className="fa fa-pencil"></i> Change</>) : 'Upload'}
                                        </a> 
                                        {(brandingData.player_logo && brandingData.player_logo.length > 0) && (
                                            <button 
                                                className="text-danger border-0 bg-transparent"
                                                data-effect="solid"
                                                data-tip="Delete Image"
                                                onClick={(e)=>setBrandingData({
                                                    ...brandingData,
                                                    player_logo:""
                                                })}
                                            >
                                                <i className="fa fa-trash"></i> 
                                            </button> 
                                        )}
                                        
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-9 ms-auto">
                                        <div className="form-check mb-4">
                                            <input 
                                                className="form-check-input" 
                                                type="checkbox" 
                                                value="" 
                                                id="flexCheckDefault"
                                                checked={brandingData.player_addlink_chk}
                                                onChange={()=>setBrandingData({...brandingData,player_addlink_chk:!brandingData.player_addlink_chk})}
                                            />
                                            <label className="form-check-label" htmlFor="flexCheckDefault">
                                                Add link to player logo
                                            </label>
                                        </div>
                                        {brandingData.player_addlink_chk && (
                                            <input 
                                                placeholder="https://prnt.sc/26gabn8" 
                                                className={`form-control border-0 w-75 mb-4 shadow-none ${errors && errors.player_link ? 'is-invalid' : ''}`} 
                                                type="text"
                                                value={brandingData.player_link}
                                                onChange={(e)=>setBrandingData({...brandingData,player_link:e.target.value})}
                                            />
                                        )}
                                        
                                        <input 
                                            type="button" 
                                            className="btn btn1 min_w150" 
                                            value="Save"
                                            onClick={handleBrandingData}
                                        />
                                        <div className="rw pt-2">
                                            <button 
                                                className="link_blue border-0 bg-transparent"
                                                onClick={(e)=>setBrandingData({
                                                    ...brandingData,
                                                    player_logo:"",
                                                    player_theme:'#ff3987',
                                                    player_addlink_chk:false,
                                                    player_link:'',
                                                })}
                                            >
                                                <i className="fa fa-refresh"></i> Restore Default
                                            </button>
                                        </div>

                                    </div>
                                </div>

                            </div>


                        </div>


                    </div>

                    <div className="tab-pane fade" id="privacy" role="tabpanel" aria-labelledby="privacy-tab">
                        <div className="privacy_sec">
                            <h6 className="mb-2">Select an option below on who can access video</h6>

                            <div className="d-none bg_gry2 p-4 mb-4">
                                <div className="form-check slect_option_r">
                                    <input 
                                        className="form-check-input" 
                                        type="radio" 
                                        name="flexRadioDefault" 
                                        id="flexRadioDefault1"
                                        checked={(privacyData.visibility === "onlyme")?true:false}
                                        onChange={()=>setPrivacyData({...privacyData,visibility:"onlyme"})}
                                    />
                                    <label className="form-check-label d-flex ms-5" htmlFor="flexRadioDefault1">
                                        <i className="me-4"><img src={process.env.PUBLIC_URL+"/assets/images/lock.png"} className="img-fluid" alt="img"/></i>
                                        <h5 className=" m-0"><span className="d-block">Only me</span><small>Only myself can see</small></h5>
                                    </label>
                                </div>

                            </div>

                            <div className=" bg_gry2 p-4">
                                <div className="form-check slect_option_r mb-4">
                                    <input 
                                        className="form-check-input" 
                                        type="radio" 
                                        name="flexRadioDefault" 
                                        id="flexRadioDefault12"
                                        checked={(privacyData.visibility === "anyone")?true:false}
                                        onChange={()=>setPrivacyData({...privacyData,visibility:"anyone"})}
                                    />
                                    <label className="form-check-label d-flex ms-5" htmlFor="flexRadioDefault12">
                                        <i className="me-4"><img src={process.env.PUBLIC_URL+"/assets/images/anyone.png"} className="img-fluid" alt="img"/></i>
                                        <h5 className=" m-0"><span className="d-block">Anyone with the link</span><small>Anyone who have this link can access</small></h5>
                                    </label>
                                </div>
                                {(privacyData.visibility === "anyone") && (
                                    <div className=" ms-5 ps-4">
                                        <div className="form-check mb-3">
                                            <input 
                                                className="form-check-input" 
                                                type="checkbox" 
                                                value="" 
                                                id="setpassword"
                                                checked={privacyData.passwordchk}
                                                onChange={()=>setPrivacyData({...privacyData,passwordchk:!privacyData.passwordchk})}
                                            />
                                            <label className="form-check-label" htmlFor="setpassword">Set password</label>
                                        </div>
                                        {privacyData.passwordchk && (
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <input 
                                                        type="text" 
                                                        className={`form-control mb-3 ${errors && errors.passwordText ? 'is-invalid' : ''}`}
                                                        onChange={(e)=>setPrivacyData({...privacyData,passwordText:e.target.value})}
                                                        value={privacyData.passwordText}
                                                    />
                                                </div>
                                            </div>
                                        )}
                                        <div className="form-check mb-3">
                                            <input 
                                                className="form-check-input" 
                                                type="checkbox" 
                                                id="setexpiry"
                                                checked={privacyData.expirarychk}
                                                onChange={()=>setPrivacyData({...privacyData,expirarychk:!privacyData.expirarychk})}
                                            />
                                            <label className="form-check-label" htmlFor="setexpiry">Set expiry</label>
                                        </div>
                                        {privacyData.expirarychk && (
                                            <div className="row mb-4">
                                                <div className="col-md-7">
                                                    <div className="input-group date" id="datepicker">
                                                        {/* <input 
                                                            type="text" 
                                                            className="form-control border-end-0 shadow-none" 
                                                            id="date" 
                                                            onChange={(e)=>setPrivacyData({...privacyData,expiraryText:e.target.value})}
                                                            value={privacyData.expiraryText}
                                                        /> */}
                                                        <DatePicker 
                                                            className={`form-control border-end-0 shadow-none ${errors && errors.expiraryText ? 'is-invalid' : ''}`}
                                                            selected={expiraryText} 
                                                            onChange={handleDateChange} 
                                                            showTimeSelect
                                                            dateFormat="MMMM d, yyyy h:mm aa"
                                                            fixedHeight
                                                            minDate={new Date()}
                                                            timeIntervals={15}
                                                            // maxDate={addMonths(new Date(), 5)}
                                                            showDisabledMonthNavigation
                                                        />
                                                        
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                        <input type="button" className="btn btn1 min_w150" value="Save" onClick={handlePrivacyData}/>

                                    </div>
                                )}
                            </div>

                        </div>

                    </div>
                </div>

            </div>

        </div>
    </>
    )
}

export default VideoSettings